// extracted by css-extract-rspack-plugin
export default {"container":"ActionBar-module__container__gU_rDYy","withoutActions":"ActionBar-module__withoutActions__ugWmuTR"};